<template lang="pug">
    LoginTeaClient(v-if="isTC")
    LoginJF(v-else-if="isJF")
    login(v-else)
</template>

<script>
import Login from '@/components/login/App.vue'
import LoginJF from '@/components/login/jfApp.vue'
import LoginTeaClient from '@/components/login/teacherClientApp.vue'

export default {
  name: 'App',
  components: { Login, LoginJF, LoginTeaClient },
  data() {
    return {
      isTC: false,
      isJF: false
    }
  },
  beforeCreate() {
    document.title = window.ConfigNew.header.title
  },
  created() {
    this.isJF = window.navigator.userAgent.match(/Electron/)
    // this.isJF = true
    this.isTC = window.navigator.userAgent.match(/tszxTeacherClient/)
  }
}
</script>
<style lang="css">
@import url('../src/ui/css/ui.css');
</style>



// WEBPACK FOOTER //
// src/App.vue